$(function () {
  var win = window;
  var doc = document;

  if (!win.requestAnimationFrame) {
    win.requestAnimationFrame = (function () {
      return win.webkitRequestAnimationFrame ||
        win.mozRequestAnimationFrame ||
        win.oRequestAnimationFrame ||
        win.msRequestAnimationFrame ||
        function (callback) { return win.setTimeout(callback, 1000 / 60); };
    })();
  }

  if (!win.cancelAnimationFrame) {
    win.cancelAnimationFrame = (function () {
      return win.webkitCancelRequestAnimationFrame ||
        win.mozCancelAnimationFrame ||
        win.oCancelAnimationFrame ||
        win.msCancelAnimationFrame ||
        function (id) { return win.cancelTimeout(id); };
    })();
  }
  var body = document.getElementsByTagName('body')[0];
  var rootElement = doc.querySelector('.cd-morph-dropdown');
  var mainNav = document.querySelector('.main-nav');
  var mainNavItems = mainNav.querySelectorAll('.has-dropdown');
  var ddl = rootElement.querySelector('.dropdown-list');
  var mq = checkMq();
  var vTransform = getProp(['transform', 'webkitTransform', 'mozTransform', 'msTransform', 'oTransform']);
  var resizing = false;

  for (var i = 0; i < mainNavItems.length; ++i) {
    mainNavItems[i].addEventListener('mouseenter', ddlMouseEnter, false);
    mainNavItems[i].addEventListener('mouseleave', ddlMouseLeave, false);
    mainNavItems[i].addEventListener('touchstart', ddlTouch, false);
    mainNavItems[i].addEventListener('keyup', ddlKeyup, false);
  }

  ddl.addEventListener('mouseleave', ddlMouseLeave, false);
  rootElement.addEventListener('click', menuClick, false);
  win.addEventListener('resize', switchNavigationTypes, false);

  resetDropdown();

  function checkMq () {
    return win.getComputedStyle(rootElement, '::before').getPropertyValue('content').replace(/'/g, '').replace(/"/g, '').split(', ')[0];
  }

  function ddlMouseLeave (e) {
    (mainNav.querySelectorAll('.has-dropdown:hover').length === 0 &&
      rootElement.querySelectorAll('.dropdown-list:hover').length === 0) &&
    delay(hideDropdown());
  }

  function ddlTouch (e) {
    if (!('ontouchstart' in window)) return;
    var selectedDropdown = ddl.querySelector('#' + e.target.data('content'));
    if (!rootElement.classList.contains('is-dropdown-visible') || !selectedDropdown.classList.contains('active')) {
      e.preventDefault();
      ddlMouseEnter(e);
    }
  }

  function menuClick (e) {
    if (e.target.classList.contains('nav-trigger')) {
      typeof e !== 'undefined' && e.preventDefault();
      rootElement.classList.toggle('nav-open');
      body.classList.toggle('body-nav');
    }
  }

  function ddlKeyup () {
    if (document.activeElement.parentNode.classList.contains('has-dropdown')) {
      return ddlMouseEnter({'target': document.activeElement.parentNode});
    }
  }

  function ddlMouseEnter (e) {
    mq = checkMq();
    if (mq !== 'desktop') return;

    var item = (e.target || this);
    var thisddl = ddl.querySelector('#' + item.getAttribute('data-content'));
    var thisddlHeight = getHeight(thisddl);
    var thisddlWidth = getWidth(thisddl.querySelector('.drop-list'));
    var thisddlLeft = getOffsetLeft(item) + getWidth(item) / 2 - thisddlWidth / 2;
    var actives = rootElement.querySelectorAll('.active');

    updateDropdown(thisddlHeight, thisddlWidth, thisddlLeft);

    for (var i = 0; i < actives.length; ++i) actives[i].classList.remove('active');
    item.classList.add('active');
    thisddl.classList.add('active');
    thisddl.classList.remove('move-left');
    thisddl.classList.remove('move-right');
    if (thisddl.previousElementSibling) thisddl.previousElementSibling.classList.add('move-left');
    if (thisddl.nextElementSibling) thisddl.nextElementSibling.classList.add('move-right');

    if (!rootElement.classList.contains('is-dropdown-visible')) {
      window.setTimeout(function () {
        rootElement.classList.add('is-dropdown-visible');
      }, 10);
    }
  }

  function updateDropdown (height, width, left) {
    ddl.style.width = width + 'px';
    ddl.style.height = height + 'px';
    ddl.style[vTransform] = 'translateX(' + left + 'px)';
  }

  function hideDropdown () {
    mq = checkMq();
    if (mq !== 'desktop') return;
    rootElement.classList.remove('is-dropdown-visible');
    var actives = rootElement.querySelectorAll('.active');
    var movelefts = rootElement.querySelectorAll('.move-left');
    var moveRights = rootElement.querySelectorAll('.move-right');
    for (var i = 0; i < actives.length; ++i) actives[i].classList.remove('active');
    for (var j = 0; j < movelefts.length; ++j) movelefts[j].classList.remove('move-left');
    for (var k = 0; k < moveRights.length; ++k) moveRights[k].classList.remove('move-right');
  }

  function resetDropdown () {
    resizing = false;
    mq = checkMq();
    if (mq !== 'mobile') return;
    ddl.removeAttribute('style');
  }

  function getHeight (el) {
    return parseInt(getComputedStyle(el).height.slice(0, -2));
  }

  function getWidth (el) {
    return parseInt(getComputedStyle(el).width.slice(0, -2));
  }

  function getOffsetLeft (el) {
    return el.getBoundingClientRect().left;
  }

  function getProp (props) {
    for (var j = 0; j < props.length; j++) {
      if (typeof document.body.style[props[j]] !== 'undefined') { return props[j]; }
    }

    return '';
  }

  function rebounce (f) {
    var scheduled, context, args;
    return function () {
      context = this;
      args = [];
      for (var i = 0; i < arguments.length; ++i) args[i] = arguments[i];
      !!scheduled && win.cancelAnimationFrame(scheduled);
      scheduled = win.requestAnimationFrame(function () {
        f.apply(context, args);
        scheduled = null;
      });
    };
  }

  function delay (f) {
    var scheduled, context, args;
    return function () {
      context = this;
      args = [];
      for (var i = 0; i < arguments.length; ++i) args[i] = arguments[i];
      !!scheduled && window.cancelTimeout(scheduled);
      scheduled = window.setTimeout(function () {
        f.apply(context, args);
        scheduled = null;
      }, 50);
    };
  }

  function switchNavigationTypes () {
    if (resizing) return;
    resizing = true;
    return rebounce(resetDropdown());
  }
});
